
export default {
  name: 'EmailVerificationBanner',
  data() {
    return {
      sendingVerificationEmail: false,
    }
  },
  methods: {
    sendVerificationEmail() {
      if (this.sendingVerificationEmail) return

      this.sendingVerificationEmail = true
      this.$userService
        .sendVerificationEmail()
        .then(() => {
          this.$swalCustomSuccess(
            this.$t('layouts.account.verificationEmailSentTitle'),
            this.$t('layouts.account.verificationEmailSentMessage')
          )
        })
        .catch(error => {
          this.$swalErrorMessage(error)
        })
        .finally(() => {
          this.sendingVerificationEmail = false
        })
    },
  },
}
